export const BLOCK_TYPE_OPTIONS = [
  { value: "hero_banner", label: "Hero banner" },
  { value: "carousel", label: "Carousel" },
  { value: "grid_banner", label: "Grid banner" },
  { value: "category_banner_grid", label: "Category banner grid" },
  { value: "slider", label: "Slider" },
  { value: "html", label: "HTML" },
  { value: "text", label: "Text" },
  { value: "best_in_category", label: "Best In Category" },
];

export const blockTypeLabel = (type) =>
  BLOCK_TYPE_OPTIONS.find((option) => option.value === type)?.label || type;
